import auth from '~/store/auth';

export function useAuth() {
  return auth;
}
